/* global axios */
import ApiClient from './ApiClient';

class CallLogsAPI extends ApiClient {
  constructor() {
    super('call_logs', { accountScoped: true });
  }

 // get all items
 getTwilioCallReport(params={}) {
  return axios.get(`${this.url}`,{
    params: {
      ...params
    }
  });
 }


}

export default new CallLogsAPI();
